var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data-available content-centered text-muted",style:({'min-height': (_vm.height + "em")})},[_vm._v("\n  "+_vm._s(_vm.message ? _vm.message : _vm.$t('No Data Available'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }